/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('.single-option-selector').on('change', function(){
  setTimeout(function(){ 
    if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
      location.reload();
    }
  }, 1);
});


  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",

      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      value: function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();


document.addEventListener('DOMContentLoaded', function()  {
  document.addEventListener('change', function(e){
    var el = e.target;

    if(el.classList.contains('product_grid_main_select') || el.closest('.product_grid_main_select')) {
      if(!el.classList.contains('product_grid_main_select')) {
        el = el.closest('.product_grid_main_select');
      }

      var selected_option = el.options[el.selectedIndex];
      var productPrices = el.closest('.product-item__info').querySelector('.price-list');
      var addToCartButtonElement = el.closest('form').querySelector('.product-form__add-button');
      productPrices.style.display = 'none';
      productPrices.innerHTML = '';
      
      var price = +(selected_option.getAttribute('data-variant-price'));
      var compare_at_price = +(selected_option.getAttribute('data-variant-compare_at_price'));

     
      if (!window.theme.showDiscount) {
        return; // Nothing to do if discount label is configured to be hidden
      }
      var discountLabel = el.closest('.product-item').querySelector('.product-item__label-list .product-label--on-sale'); 

      if (discountLabel) {

        if (price >= compare_at_price) {
          discountLabel.style.display = 'none';
        } else {

          var savings = null;

          if (window.theme.discountMode === 'percentage') {
            savings = "".concat(Math.round((compare_at_price - price) * 100 / compare_at_price), "%");
          } else {
            savings = "<span data-money-convertible>".concat(Currency.formatMoney(compare_at_price - price, window.theme.moneyFormat), "</span>");
          }

          discountLabel.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace('{{savings}}', savings));
          discountLabel.style.display = 'inline-block';
        }
      }

      if (compare_at_price > price ) {
        productPrices.innerHTML += "<span class=\"price price--highlight\" data-money-convertible>".concat(Currency.formatMoney(price, window.theme.moneyFormat), "</span>");
        productPrices.innerHTML += "<span class=\"price price--compare\" data-money-convertible>".concat(Currency.formatMoney(compare_at_price, window.theme.moneyFormat), "</span>");
      } else {
        productPrices.innerHTML += "<span class=\"price\" data-money-convertible>".concat(Currency.formatMoney(price, window.theme.moneyFormat), "</span>");
      }
      productPrices.style.display = '';

      var variant_available  = selected_option.getAttribute('data-variant-available');
      if (variant_available == 'true') {
        addToCartButtonElement.removeAttribute('disabled');
        addToCartButtonElement.classList.remove('button--disabled');
        addToCartButtonElement.classList.add('button--primary');
        addToCartButtonElement.setAttribute('data-action', 'add-to-cart');
        addToCartButtonElement.innerHTML = window.languages.productFormAddToCart;
      } else {
        addToCartButtonElement.setAttribute('disabled', 'disabled');
        addToCartButtonElement.classList.add('button--disabled');
        addToCartButtonElement.classList.remove('button--primary');
        addToCartButtonElement.removeAttribute('data-action');
        addToCartButtonElement.innerHTML = window.languages.productFormSoldOut;
      }
      
      var productImageEl = el.closest('.product-item').querySelector('.product-item__primary-image');
      var variant_image =  selected_option.getAttribute('data-variant_featured_media');
      productImageEl.setAttribute('srcset',variant_image);
      productImageEl.setAttribute('data-srcset',variant_image);
      
      
      
        var productFormInventoryElement = el.closest('.product-item__info').querySelector('.product-item__inventory'),
            variantInventoryManagement = selected_option.getAttribute('data-inventory_management'),
            variantInventoryPolicy = selected_option.getAttribute('data-inventory_policy'),
            variantInventoryQuantity = selected_option.getAttribute('data-inventory_quantity'),
            variantInventoryMessage = selected_option.getAttribute('data-inventory_message'),
            inventoryThreshold = selected_option.getAttribute('data-inventory_threshold')*1;

        if (!productFormInventoryElement) {
          return; // Sometimes merchant remove element from the code without taking care of JS... so let's be defensive
        }

        productFormInventoryElement.classList.remove('inventory--high');
        productFormInventoryElement.classList.remove('inventory--low');

        if (variant_available == 'true') {
          if (null !== variantInventoryManagement && variantInventoryPolicy === 'deny' && inventoryThreshold > 0) {
            if (variantInventoryQuantity <= inventoryThreshold) {
              productFormInventoryElement.classList.add('inventory--low');
            } else {
              productFormInventoryElement.classList.add('inventory--high');
            }
          } else {
            productFormInventoryElement.classList.add('inventory--high');
          }
        }

        productFormInventoryElement.innerHTML = variantInventoryMessage;
      
    }
  });
  
});